import { FC, ReactElement, useMemo } from 'react';
import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';

import { AppContainer } from '@/_app/AppContainer';
import { PageTitleProvider } from '@/_app/providers/PageTitleProvider';
import { PC } from '@/_pages/types';
import { Meta, MetaData } from '@/shared/components';

import '@/_app/styles/index.css';

import nextI18NextConfig from '../../next-i18next.config';

type AppPropsWithLayout = AppProps & {
  Component: PC;
};

const pageTexts = {
  title: 'Owner.One App - Assets Data Repository and Wealth Transfer',
  description:
    'Algorithmic transfer for your capital and assets data to your family. No third-parties. For owners of $3m-99m',
};

const defaultLayout = (page: ReactElement) => page;

const MyApp: FC<AppPropsWithLayout> = ({ Component, pageProps }) => {
  const getLayout = Component.getLayout ?? defaultLayout;

  const metaData: MetaData = useMemo(() => {
    if (Component.getMetaData) {
      return Component.getMetaData(pageProps);
    }

    return {
      title: Component.getTitle ? `${Component.getTitle()} | ${pageTexts.title}` : pageTexts.title,
      description: pageTexts.description,
    };
  }, [Component, pageProps]);

  return (
    <>
      <Meta metaData={metaData} />
      <PageTitleProvider title={Component.getTitle?.()}>
        <AppContainer>
          <main>{getLayout(<Component {...pageProps} />)}</main>
        </AppContainer>
      </PageTitleProvider>
    </>
  );
};

export default appWithTranslation(MyApp, nextI18NextConfig);
